import { render, staticRenderFns } from "./APImanagement.vue?vue&type=template&id=27e175c4&scoped=true&"
import script from "./APImanagement.vue?vue&type=script&lang=js&"
export * from "./APImanagement.vue?vue&type=script&lang=js&"
import style0 from "./APImanagement.vue?vue&type=style&index=0&id=27e175c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e175c4",
  null
  
)

export default component.exports